import {put, takeEvery, debug} from '../../lib'
import {REQUEST_ERROR, doCONNECTIVITY_SERVICE_UNAVAILABLE_SET} from '../state'
import {REQUEST_IDENTITY_REFRESH_TOKEN_SUBMIT} from '..'

// the outcomes an ordinary request reports when the backend is unreachable rather than
// unhappy. `null` is what `baseRequest` reports for a transport failure (no response at all);
// `undefined` is NOT in this list on purpose -- a REQUEST_ERROR raised by schema validation never
// reached the network and carries no `statusCode`, and an outage notice would be a lie.
export const SERVICE_UNAVAILABLE_STATUS_LIST: ReadonlyArray<number | null> = [null, 502, 503, 504]

// Checked inside a function, NOT captured at module scope: this module and the '..' barrel are
// part of the existing lib/store init cycle, so the constant is still `undefined` while this file
// is being evaluated. A module-scope capture would compare against `undefined` -- silently, with
// no throw -- and every refresh failure would raise the ordinary-503 notice on top of the
// reconnecting one. See the same note in `handle_expired_token.ts`.
const isRefreshRequest = (fromType: string): boolean => fromType === REQUEST_IDENTITY_REFRESH_TOKEN_SUBMIT

/**
 * Ordinary-503 detection. A non-refresh request that answered 502/503/504, or did not
 * answer at all, stamps `connectivity.serviceUnavailableAt`; `ConnectionNoticeBanner` shows the
 * temporary-unavailable notice for a few seconds and nothing is retried.
 *
 * The transient refresh attempts dispatch no REQUEST_ERROR at all, so they never reach here --
 * this guard only covers the refresh's terminal failures, whose story the reconnecting notice and
 * the login page already tell.
 */
export function* handleServiceUnavailable({payload}: any) {
  debug('saga*handleServiceUnavailable')

  const {fromType, statusCode} = payload ?? {}

  if (!SERVICE_UNAVAILABLE_STATUS_LIST.includes(statusCode)) return
  if (isRefreshRequest(fromType)) return

  yield put(doCONNECTIVITY_SERVICE_UNAVAILABLE_SET({serviceUnavailableAt: Date.now()}))
}

export function* handleServiceUnavailableSaga() {
  yield takeEvery(REQUEST_ERROR, handleServiceUnavailable)
}
